var _circle, _circle2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _rect, _circle3, _path9, _circle4, _circle5, _circle6, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _path10, _rect10, _rect11, _path11, _path12, _rect12, _circle7, _circle8, _path13, _path14, _path15, _rect13, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgListDocument(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    fill: "none",
    viewBox: "0 0 165 144",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 89.0151,
    cy: 72.3784,
    r: 71.3784,
    fill: "#DAE3F2"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 89.0151,
    cy: 72.3784,
    r: 58.0615,
    fill: "#DAE3F2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M140.019 2.19849V7.39206",
    stroke: "#8EA1B8",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M142.615 4.79529L137.422 4.79529",
    stroke: "#8EA1B8",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.51953 117.922V123.116",
    stroke: "#0083FC",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.11572 120.519L1.92215 120.519",
    stroke: "#0083FC",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M34.416 4.19604L38.4111 8.32427",
    stroke: "#0083FC",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M42.1401 1.26636V6.1936",
    stroke: "#0083FC",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M31.4863 11.7866H36.5467",
    stroke: "#0083FC",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M42.1401 21.2416C42.1401 16.5346 45.9559 12.7188 50.6629 12.7188H128.966C133.673 12.7188 137.489 16.5346 137.489 21.2416V125.379C137.489 130.086 133.673 133.902 128.966 133.902H50.6629C45.9559 133.902 42.1401 130.086 42.1401 125.379V21.2416Z",
    fill: "#8EA1B8"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 49.728,
    y: 19.3772,
    width: 80.17,
    height: 107.867,
    fill: "white"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 67.1757,
    cy: 38.82,
    r: 7.99012,
    fill: "url(#paint0_linear_437_3802)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.4819 36.579C70.6899 36.787 70.6899 37.1243 70.4819 37.3323L66.7532 41.0609C66.5452 41.2689 66.2079 41.2689 65.9999 41.0609L64.1355 39.1967C63.9275 38.9887 63.9275 38.6514 64.1355 38.4434C64.3435 38.2353 64.6808 38.2353 64.8888 38.4433L66.3765 39.9309L69.7286 36.579C69.9366 36.371 70.2739 36.371 70.4819 36.579Z",
    fill: "white"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 67.1757,
    cy: 61.1923,
    r: 7.99012,
    fill: "#0083FC"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 67.1757,
    cy: 84.6299,
    r: 7.99012,
    fill: "url(#paint1_linear_437_3802)"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 67.1757,
    cy: 108.068,
    r: 7.99012,
    fill: "#0083FC"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 80.4927,
    y: 34.0259,
    width: 30.0961,
    height: 2.39703,
    rx: 1.19852,
    fill: "#8EA1B8"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 80.4927,
    y: 56.6644,
    width: 21.307,
    height: 2.39703,
    rx: 1.19852,
    fill: "#8EA1B8"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 80.4927,
    y: 80.1022,
    width: 34.6238,
    height: 2.39703,
    rx: 1.19852,
    fill: "#8EA1B8"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 80.4927,
    y: 40.6842,
    width: 34.6238,
    height: 2.39703,
    rx: 1.19852,
    fill: "#8EA1B8"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 80.4927,
    y: 63.323,
    width: 28.7644,
    height: 2.39703,
    rx: 1.19852,
    fill: "#8EA1B8"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 80.4927,
    y: 86.7605,
    width: 30.0961,
    height: 2.39703,
    rx: 1.19852,
    fill: "#8EA1B8"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 80.4927,
    y: 103.54,
    width: 30.0961,
    height: 2.39703,
    rx: 1.19852,
    fill: "#8EA1B8"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 80.4927,
    y: 110.465,
    width: 34.6238,
    height: 2.39703,
    rx: 1.19852,
    fill: "#8EA1B8"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M85.0248 7.12573C84.3561 7.12573 83.7316 7.45993 83.3607 8.01633L82.0013 10.0555H75.8335C74.7289 10.0555 73.8335 10.9509 73.8335 12.0555V20.8397C73.8335 21.9442 74.7289 22.8397 75.8335 22.8397H104.06C105.165 22.8397 106.06 21.9442 106.06 20.8397V12.0555C106.06 10.9509 105.165 10.0555 104.06 10.0555H97.8928L96.5333 8.01633C96.1624 7.45993 95.5379 7.12573 94.8692 7.12573H85.0248Z",
    fill: "#0083FC"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 35.9087,
    y: 130,
    width: 47.4282,
    height: 3.90232,
    fill: "#3B3953"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 83.3369,
    y: 130,
    width: 3.30196,
    height: 3.90232,
    fill: "#015BD7"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M35.9085 130L29.7549 132.101L35.9085 133.902V130Z",
    fill: "#8EA1B8"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M31.8561 131.351L29.7549 132.101L31.8561 132.702V131.351Z",
    fill: "#0083FC"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 18.9683,
    y: 133.902,
    width: 141.425,
    height: 1.33169,
    rx: 0.665843,
    fill: "#141046"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 160.394,
    cy: 76.1071,
    r: 3,
    stroke: "#0083FC",
    strokeWidth: 1.45744
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 27.2248,
    cy: 35.3575,
    r: 3,
    stroke: "#8EA1B8",
    strokeWidth: 1.45744
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.4819 58.9513C70.6899 59.1593 70.6899 59.4966 70.4819 59.7046L66.7532 63.4332C66.5452 63.6412 66.2079 63.6412 65.9999 63.4332L64.1355 61.569C63.9275 61.361 63.9275 61.0237 64.1355 60.8157C64.3435 60.6077 64.6808 60.6076 64.8888 60.8156L66.3765 62.3032L69.7286 58.9513C69.9366 58.7433 70.2739 58.7433 70.4819 58.9513Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.4819 82.3889C70.6899 82.597 70.6899 82.9342 70.4819 83.1423L66.7532 86.8708C66.5452 87.0788 66.2079 87.0788 65.9999 86.8708L64.1355 85.0066C63.9275 84.7986 63.9275 84.4613 64.1355 84.2533C64.3435 84.0453 64.6808 84.0453 64.8888 84.2533L66.3765 85.7408L69.7286 82.3889C69.9366 82.1809 70.2739 82.1809 70.4819 82.3889Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M70.1053 106.203L66.3766 109.932L64.5122 108.068",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 76,
    y: 12,
    width: 28,
    height: 9,
    stroke: "white",
    strokeLinecap: "round",
    strokeDasharray: "4 4"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_437_3802",
    x1: 59.1855,
    y1: 30.8298,
    x2: 75.1658,
    y2: 46.8101,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2AE7AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0083FC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_437_3802",
    x1: 59.1855,
    y1: 76.6398,
    x2: 75.1658,
    y2: 92.62,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2AE7AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0083FC"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgListDocument);
export default __webpack_public_path__ + "static/media/list-document.e3047cd33441c79302d5b325bcab8ce7.svg";
export { ForwardRef as ReactComponent };